import Helper from "../../playcreator/functions/Helper.js";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  play: Helper.defaultPlayPrintSettings,
  playbook: Helper.defaultPlaybookPrintSettings,
};

const settings = createSlice({
  name: "printSettings",
  initialState,
  reducers: {
    defaultSettings(state, action) {
      state[action.payload.type] =
        action.payload.type === "play"
          ? Helper.defaultPlayPrintSettings
          : Helper.defaultPlaybookPrintSettings;
    },
    cover(state, action) {
      state[action.payload.type].cover = {
        ...state[action.payload.type].cover,
        ...action.payload.value,
      };
    },
    cols(state, action) {
      state[action.payload.type].cols = action.payload.value;
    },
    courtColor(state, action) {
      state[action.payload.type].courtColor = action.payload.value;
    },
    pageBreakAfterPlay(state, action) {
      state[action.payload.type].pageBreakAfterPlay = action.payload.value;
    },
    printPlayDescriptions(state, action) {
      state[action.payload.type].printPlayDescriptions = action.payload.value;
    },
    printShowLink(state, action) {
      state[action.payload.type].showLink = action.payload.value;
    },
    printPhaseDescriptions(state, action) {
      state[action.payload.type].printPhaseDescriptions = action.payload.value;
    },
    printPhaseTitles(state, action) {
      state[action.payload.type].printPhaseTitles = action.payload.value;
    },
    pagePadding(state, action) {
      state[action.payload.type].pagePadding = action.payload.value;
    },
    fontSizes(state, action) {
      state[action.payload.type].fontSizes = action.payload.value;
    },
    objectSizeFactor(state, action) {
      state[action.payload.type].objectSizeFactor = action.payload.value;
    },
    overwriteScaling(state, action) {
      state[action.payload.type].overwriteScaling = action.payload.value;
    },
  },
});

export default settings.reducer;
export const {
  cover,
  defaultSettings,
  cols,
  courtColor,
  pageBreakAfterPlay,
  printPlayDescriptions,
  printPhaseDescriptions,
  printPhaseTitles,
  pagePadding,
  fontSizes,
  objectSizeFactor,
  overwriteScaling,
  printShowLink,
} = settings.actions;
